import { useContext, useEffect, useMemo, useRef, useState } from "react";
import styles from "./DuplicateOrders.module.scss";
import { TabView, TabPanel } from "primereact/tabview";
import DuplicateOrdersScreen from "../duplicate-orders-screen/duplicateOrdersScreen";
import LoginUserDataContext from "../../store/login";
import { Message } from 'primereact/message';

export default function DuplicateOrders() {
  const regionToIndex = {
    47: 1,
    49: 2,
    50: 3,
    43: 4,
    5: 5,
  };
  const [loggedInData, setLoggedInData] = useContext(LoginUserDataContext);
  const authorizedRoleId = [1, 2, 4];
  const isAuthorizedToViewAllTabs = authorizedRoleId.includes(loggedInData?.roleId);
  const defaultIndex = isAuthorizedToViewAllTabs ? 0 : regionToIndex[loggedInData?.regionId] ?? null;
  const [activeIndex, setActiveIndex] = useState(defaultIndex);
  const showMessage = (isAuthorizedToViewAllTabs==false && loggedInData?.regionId==null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    setActiveIndex(defaultIndex);
  }, [loggedInData]);
 const REGION_TABS = [
    { regionId: 42, label: "Baja", name: "tbcp", btnCol: "md:col-3", span: "md:col-4", isVisible: false },
    { regionId: 47, label: "TFNW", name: "tfnw", btnCol: "md:col-4", span: "md:col-4 xl:col-8", isVisible: false },
    { regionId: 49, label: "TFFL", name: "tffl", btnCol: "md:col-3", span: "md:col-4", isVisible: false },
    { regionId: 50, label: "TFSW", name: "tfsw", btnCol: "md:col-4", span: "md:col-4 xl:col-8", isVisible: false },
    { regionId: 43, label: "TFTX", name: "tftx", btnCol: "md:col-4", span: "md:col-4 xl:col-8", isVisible: false },
    { regionId: 5, label: "TFTN", name: "tftn", btnCol: "md:col-4", span: "md:col-4 xl:col-8", isVisible: false },
  ];

  const visibleTabs = REGION_TABS.map(tab => ({
    ...tab,
    isVisible: isAuthorizedToViewAllTabs || loggedInData?.regionId === tab.regionId
  }));

  return (
    <>
      <div className="grid ">
        <div className="col-12 ">
          {showMessage ? (
            <div className="flex  justify-content-center align-items-center md:mt-5">
              <Message
                severity="warn"
                text="Contact the admin to assign a role or region to this account"
              />
            </div>
          ) : (
            <TabView
              className={`${styles.noBorderForTab} ${styles.tabViewBotttomBorder}`}
              activeIndex={activeIndex}
              onTabChange={(e) => { setActiveIndex(e.index) }}
            >
              {visibleTabs.map((tab, index) => tab?.isVisible && (
                <TabPanel
                  key={tab.regionId}
                  header={tab.label}
                  headerClassName={styles.tabWidth}
                  className={`${styles.tab} ${activeIndex === index ? styles.activeTab : styles.InactiveTab
                    }`}
                >
                  <DuplicateOrdersScreen
                    regionName={tab.name}
                    btnCol={tab.btnCol}
                    updateColSpan={tab.span}
                    gridStyle={tab.gridStyle}
                  />
                </TabPanel>
              ))}
            </TabView>
          )}
        </div>
      </div>
    </>
  );
}
